<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Controle Cobranças</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item">Controle Cobranças</li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                        <v-form>
                                            <v-container>
                                                <div class="row gp-query-filters">
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <v-autocomplete v-model="GarantidoraSelected" :items="ListGarantidorasGeral" item-title="garNomeEmpresa" item-value="garId"
                                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhum registro encontrado" @update:model-value="BuscaImobiliarias()" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3"
                                                        v-if="User.tpeid == 1 || User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Imobiliária</label>
                                                            <v-autocomplete v-model="ImobiliariaSelected" :items="ListImobiliarias" item-title="imoNomeEmpresa" item-value="imoId"
                                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhum registro encontrado" @update:model-value="SelecionarConsumidor()" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3"
                                                        v-if="ImobiliariaSelected != '' && ImobiliariaSelected != null && ListConsumidor != ''">
                                                        <div class="form-group">
                                                            <label>Cliente</label>
                                                            <v-autocomplete v-model="selectedConsumidor" :items="ListConsumidor"
                                                                item-title="nomeConcatenado" return-object density="compact" variant="outlined"
                                                                placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhum cliente encontrado" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>ID da contratação</label>
                                                            <input v-model.trim="PedidoSelected" type="number" min="1" step="1"
                                                                class="form-control" placeholder="Digite o código" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Forma de pagamento</label>
                                                            <select v-model="PagamentoSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListPagamentosGeral"
                                                                    :key="optionTipo.cfpId" :value="optionTipo.cfpId">{{
                                                                        optionTipo.cfpNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Ano Referência</label>
                                                            <select v-model="AnoSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListAnoGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Mês Referência</label>
                                                            <select v-model="MesSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListMesGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Situação</label>
                                                            <select v-model="SituacaSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSituacaoGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12 gp-query-actions">
                                                        <div class="form-group">
                                                            <button type="button" class="btn btn-info"
                                                                style="color:#ffffff;" @click="Filtar()">
                                                                <i class="fas fa-search"></i> Pesquisar
                                                            </button>
                                                            <a href="#" @click.prevent="Cancel()"
                                                                class="btn btn-outline-secondary"><i class="fas fa-eraser"></i> Limpar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Resultado</h4>
                                </div>
                            </div>
                            <div class="card-body"
                                v-if="ListCobrancas != '' && ListGarantidorasGeral != null && ListImobiliariasGeral != '' && ListClientesGeral != ''">
                                <v-row>
                                    <v-col cols="12" md="3" style="text-align: right;margin-bottom: 5px;">
                                        <input v-model="NewData" type="date" class="form-control"
                                            placeholder="Data Pagamento" />
                                    </v-col>
                                    <v-col cols="12" md="2"
                                        style="text-align: right;padding-right: 15px;padding-top: 20px;">
                                        <button @click="AtualizarPagamentoMassa()" class="btn-sm btn-info">Atualizar
                                            Selecionados</button>
                                    </v-col>

                                </v-row>

                                <adm-data-table :headers="gridHeaders" :export-headers="headers" :items="ListCobrancas" v-model="itemsSelected"
                                    :show-filters="false" :show-export="true" file-name="controle-cobrancas"
                                    :export-metadata="metadadosExportacao"
                                    :export-formatters="formatadoresExportacao"
                                    :export-number-formats="formatosNumericosExportacao"
                                    total-field="pmbValorParcela" total-label="Valor total filtrado"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina">
                                    <template #item-entidadesResumo="item">
                                        <div class="gp-charge-summary">
                                            <strong>{{ nomeGarantidora(item) }}</strong>
                                            <span>{{ nomeImobiliaria(item) }}</span>
                                        </div>
                                    </template>
                                    <template #item-clienteResumo="item">
                                        <div class="gp-charge-summary">
                                            <strong>{{ nomeCliente(item) }}</strong>
                                            <small>{{ documentoCliente(item) }}</small>
                                        </div>
                                    </template>
                                    <template #item-pmbValorParcela="item">
                                        <span>{{ formatarValor(item.pmbValorParcela) }}</span>
                                    </template>
                                    <template #item-pmbDataVencimento="item">
                                        <span>{{ item.pmbDataVencimento != null ? formattedDate(item.pmbDataVencimento)
                                            :
                                            null }}</span>
                                    </template>
                                    <template #item-pmbDataPagamento="item">
                                        <span>{{ item.pmbDataPagamento != null ? formattedDate(item.pmbDataPagamento) :
                                            null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions">
                                        <v-btn icon @click="ConfirmaPgto(item)" style="margin-right: 10px;"
                                            variant="text" v-if="item.pmbDataPagamento == null">
                                            <v-icon class="editiconcor">mdi-cash</v-icon>
                                            <v-tooltip activator="parent" location="top">Confirmar Pagamento</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="EmissaoNF(item)" style="margin-right: 10px;" variant="text" v-show="false"
                                            v-if="(item.snfId == 10 || item.snfId == 0 || item.snfId == 40) && User.tpeid != 3">
                                            <v-icon class="editiconcor">mdi-file-code</v-icon>
                                            <v-tooltip activator="parent" location="top">Emissão e-NF</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="BaixaNF(item, '1')" style="margin-right: 10px;" v-show="false"
                                            variant="text" v-if="item.snfId == 50 && User.tpeid != 3">
                                            <v-icon class="editiconcor"
                                                style="color: green;">mdi-file-powerpoint</v-icon>
                                            <v-tooltip activator="parent" location="top">Baixar Pdf e-NF</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="BaixaNF(item, '2')" style="margin-right: 10px;" v-show="false"
                                            variant="text" v-if="item.snfId == 50 && User.tpeid != 3">
                                            <v-icon class="editiconcor" style="color: green;">mdi-file-excel</v-icon>
                                            <v-tooltip activator="parent" location="top">Baixar xml e-NF</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="ModalStatus(item)" style="margin-right: 10px;" v-show="false"
                                            variant="text"
                                            v-if="(item.snfId == 35 || item.snfId == 40 || item.snfId == 0) && User.tpeid != 3">
                                            <v-icon class="editiconcor" style="color: orange;">mdi-file-find</v-icon>
                                            <v-tooltip activator="parent" location="top">Status e-NF</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="CancelarNF(item)" style="margin-right: 10px;" variant="text" v-show="false"
                                            v-if="item.snfId == 50 && User.tpeid != 3">
                                            <v-icon class="editiconcor" style="color: red;">mdi-file-remove</v-icon>
                                            <v-tooltip activator="parent" location="top">Cancelar e-NF</v-tooltip>
                                        </v-btn>
                                        <div v-if="(item.snfId == 20 || item.snfId == 30) && User.tpeid != 3" v-show="false">
                                            Processando</div>
                                        </div>
                                    </template>
                                    <template #item-select="item">
                                        <div class="gp-selection-cell" v-if="item.pmbDataPagamento == null">
                                            <v-checkbox v-model="itemsSelected" :value="item" density="compact" hide-details></v-checkbox>
                                        </div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <v-row justify="center">
        <v-dialog v-model="dialogPagamento" persistent transition="dialog-bottom-transition" style="width: 520px;">
            <v-card>
                <v-card-text style="padding: 16px 0px 10px" v-if="itemAtual != ''">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <strong>Pedido: {{ itemAtual.pedId }}</strong>
                                </v-col>
                                <v-col cols="12" md="12">
                                    Parcela: {{ itemAtual.pmbParcela }}
                                </v-col>
                                <v-col cols="12" md="12">
                                    <label>Valor Parcela</label>
                                    <input v-model="itemAtual.pmbValorParcela" type="text" class="form-control"
                                        placeholder="Valor Parcela" />
                                </v-col>
                                <v-col cols="12" md="12" v-if="PermiteAjusteVencimento(itemAtual.pmbDataVencimento)">
                                    <label>Data Vencimento</label>
                                    <input v-model="itemAtual.pmbDataVencimento" type="date" class="form-control"
                                        placeholder="Data Vencimento" />
                                </v-col>
                                <v-col cols="12" md="12">
                                    <label>Data Pagamento</label>
                                    <input v-model="pmbDataPagamento" type="date" class="form-control"
                                        placeholder="Data Pagamento" />
                                </v-col>
                                <v-col cols="12" md="12" v-if="PermiteAjusteVencimento(itemAtual.pmbDataVencimento)">
                                    <v-checkbox v-model="ajustarVencimentoParcelasFuturas"
                                        label="Ajustar vencimento das parcelas futuras" hide-details></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="" style="padding: 5px;margin: 5px;font-size: 13px;color:#000000;"
                        @click.prevent="dialogPagamento = false">Cancelar</v-btn>
                    <v-btn class="btn btn-success" style="padding: 5px;margin: 5px;font-size: 13px;color:#ffffff;"
                        @click.prevent="AtualizaPagamento(pmbDataPagamento)">Atualizar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
    <v-dialog v-model="dialogStatusNota" max-width="900px">
        <v-card>
            <v-card-title class="text-h6">Histórico de Processamento</v-card-title>
            <v-card-text>
                <adm-data-table :headers="headers2" :items="statusArray" v-model="itemsSelected" alternating
                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                    <template #item-dataEnvio="item">
                        {{ formattedDateHr(item.dataEnvio) }}
                    </template>
                    <template #item-mensagem="item">
                        <div style="max-width: 300px; white-space: normal;">
                            {{ item.mensagem || '-' }}
                        </div>
                    </template>
                </adm-data-table>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialogStatusNota = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'
import EasyDataTable from 'vue3-easy-data-table'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import moment from 'moment'

export default {
  name: 'ControleCobrancasView',
  components: {
    EasyDataTable,
    moment
  },
  data: () => ({
    User: {
      garid: 0,
      tpeid: 0,
      pesid: 0
    },
    editor: DecoupledEditor,
    tab: null,
    searchValue: '',
    itemsSelected: [],
    ListCobrancasGeral: [],
    ListCobrancas: [],
    GarantidoraSelected: null,
    ListGarantidorasGeral: [],
    ImobiliariaSelected: null,
    ListImobiliariasGeral: [],
    ListImobiliarias: [],
    PedidoSelected: null,
    PagamentoSelected: null,
    ListPagamentosGeral: [],
    AnoSelected: null,
    ListAnoGeral: [],
    MesSelected: null,
    ListMesGeral: [
      { Id: 1, Nome: 'Janeiro' },
      { Id: 2, Nome: 'Fevereiro' },
      { Id: 3, Nome: 'Março' },
      { Id: 4, Nome: 'Abril' },
      { Id: 5, Nome: 'Maio' },
      { Id: 6, Nome: 'Junho' },
      { Id: 7, Nome: 'Julho' },
      { Id: 8, Nome: 'Agosto' },
      { Id: 9, Nome: 'Setembro' },
      { Id: 10, Nome: 'Outubro' },
      { Id: 11, Nome: 'Novembro' },
      { Id: 12, Nome: 'Dezembro' }
    ],
    SituacaSelected: null,
    ListSituacaoGeral: [
      { Id: 1, Nome: 'Pago' },
      { Id: 2, Nome: 'Em Aberto' }
    ],
    ListClientes: [],
    ListClientesGeral: [],
    itemAtual: '',
    pmbDataPagamento: '',
    ajustarVencimentoParcelasFuturas: false,
    dialogPagamento: false,
    itemsSelected: [],
    NewData: '',
    selectedConsumidor: null,
    ListConsumidor: [],
    headers: [],
    statusArray: [],
    dialogStatusNota: false,
    headers2: [
      { text: 'ID', value: 'snfId', align: 'start' },
      { text: 'Status', value: 'snfNome' },
      { text: 'Data de Envio', value: 'dataEnvio' },
      { text: 'Observação', value: 'mensagem' }
    ],
    Endereco: []
  }),
  computed: {
    gridHeaders () {
      const resultado = []
      let entidadesIncluidas = false
      let clienteIncluido = false

      this.headers.forEach(header => {
        if (header.value === 'garId' || header.value === 'imoId') {
          if (!entidadesIncluidas) {
            resultado.push({ text: 'Garantidora / Imobiliária', value: 'entidadesResumo', sortable: false })
            entidadesIncluidas = true
          }
        } else if (header.value === 'cliNomeEmpresa' || header.value === 'cliDocumento') {
          if (!clienteIncluido) {
            resultado.push({ text: 'Cliente / Documento', value: 'clienteResumo', sortable: false })
            clienteIncluido = true
          }
        } else {
          resultado.push(header)
        }
      })

      return resultado
    },
    totalCobrancas () {
      return (this.ListCobrancas || []).reduce((total, item) =>
        total + (Number(item.pmbValorParcela) || 0), 0)
    },
    metadadosExportacao () {
      return [
        { label: 'Garantidora', value: this.nomeGarantidoraSelecionada() },
        { label: 'Imobiliária', value: this.nomeImobiliariaSelecionada() },
        { label: 'Cliente', value: this.selectedConsumidor?.nomeConcatenado || 'Todos' },
        { label: 'ID da contratação', value: this.PedidoSelected || 'Todas' },
        { label: 'Forma de pagamento', value: this.nomeFormaPagamentoSelecionada() },
        { label: 'Ano de referência', value: this.AnoSelected || 'Todos' },
        { label: 'Mês de referência', value: this.nomeMesSelecionado() },
        { label: 'Situação', value: this.nomeSituacaoSelecionada() }
      ]
    },
    formatadoresExportacao () {
      return {
        garId: (_, item) => this.nomeGarantidora(item),
        imoId: (_, item) => this.nomeImobiliaria(item),
        cliNomeEmpresa: (_, item) => this.nomeCliente(item),
        cliDocumento: (_, item) => this.documentoCliente(item),
        pmbValorParcela: value => Number(value || 0),
        pmbDataVencimento: value => value ? this.formattedDate(value) : '',
        pmbDataPagamento: value => value ? this.formattedDate(value) : ''
      }
    },
    formatosNumericosExportacao () {
      return { pmbValorParcela: '#,##0.00' }
    }
  },
  methods: {
    nomeGarantidoraSelecionada () {
      if (!this.GarantidoraSelected) return 'Todas'
      return this.ListGarantidorasGeral.find(x => x.garId == this.GarantidoraSelected)?.garNomeEmpresa || this.GarantidoraSelected
    },
    nomeImobiliariaSelecionada () {
      if (!this.ImobiliariaSelected) return 'Todas'
      return this.ListImobiliariasGeral.find(x => x.imoId == this.ImobiliariaSelected)?.imoNomeEmpresa || this.ImobiliariaSelected
    },
    nomeFormaPagamentoSelecionada () {
      if (!this.PagamentoSelected) return 'Todas'
      return this.ListPagamentosGeral.find(x => x.cfpId == this.PagamentoSelected)?.cfpNome || this.PagamentoSelected
    },
    nomeMesSelecionado () {
      if (!this.MesSelected) return 'Todos'
      return this.ListMesGeral.find(x => x.Id == this.MesSelected)?.Nome || this.MesSelected
    },
    nomeSituacaoSelecionada () {
      if (!this.SituacaSelected) return 'Todas'
      return this.ListSituacaoGeral.find(x => x.Id == this.SituacaSelected)?.Nome || this.SituacaSelected
    },
    nomeGarantidora (item) {
      return this.ListGarantidorasGeral.find(x => x.garId == item.garId)?.garNomeEmpresa || '—'
    },
    nomeImobiliaria (item) {
      return this.ListImobiliariasGeral.find(x => x.imoId == item.imoId)?.imoNomeEmpresa || '—'
    },
    nomeCliente (item) {
      return this.ListClientesGeral.find(x => x.cliId == item.cliId)?.cliNomeEmpresa || '—'
    },
    documentoCliente (item) {
      return this.ListClientesGeral.find(x => x.cliId == item.cliId)?.cliDocumento || ''
    },
    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      if (valor === null || valor === undefined || valor === '') {
        return '0,00'
      }

      const numero = Number(valor)
      return Number.isFinite(numero)
        ? numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '0,00'
    },
    BuscaImobiliarias () {
      this.ImobiliariaSelected = null
      this.ListImobiliarias = []
      this.selectedConsumidor = null
      this.ListConsumidor = []

      if (this.GarantidoraSelected === null || this.GarantidoraSelected === '' || this.GarantidoraSelected === undefined) {
        return
      }

      axios.get('/Telas/ControleCobrancaGarantidoras/GetByGarIdParIdImobiliarias/' + this.GarantidoraSelected + '/0')
        .then(response => {
          if (response.data.length > 0) {
            this.ListImobiliarias = response.data.sort((a, b) =>
              a.imoNomeEmpresa.localeCompare(
                b.imoNomeEmpresa,
                'pt',
                { sensitivity: 'base' }
              )
            )
          } else {
            this.ListImobiliarias = []
          }
        })
    },
    async SelecionarConsumidor () {
      if (this.ImobiliariaSelected) {
        this.ListConsumidor = []
        this.selectedConsumidor = null

        const response = await axios.get(
                    `/Telas/ControleCobrancaGarantidoras/GetByGarIdImoIdClientes/0/${this.ImobiliariaSelected}`
        )

        // filtra, ordena e então mapeia
        this.ListConsumidor = response.data
          .filter(x => x.cliAtivo) // só ativos
          .sort((a, b) =>
            a.cliNomeEmpresa.localeCompare(b.cliNomeEmpresa, 'pt', { sensitivity: 'base' })
          ) // ordena alfabeticamente
          .map(item => ({ // adiciona nomeConcatenado
            ...item,
            nomeConcatenado: `${item.cliNomeEmpresa} - ${item.cliDocumento}`
          }))
      }
    },
    Cancel () {
      // window.location.reload();
      this.$router.go(0)
    },
    Filtar () {
      if (this.GarantidoraSelected === '' || this.GarantidoraSelected === null) {
        this.$mensagemAviso('Selecione uma Garantidora.')
      } else {
        axios.get('/Telas/ControleCobrancaGarantidoras/GetAllByGarIdPedidoControle/' + this.GarantidoraSelected)
          .then(response => {
            this.ListCobrancasGeral = response.data
            if (this.ImobiliariaSelected != null) {
              this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.imoId == this.ImobiliariaSelected)
            }
            if (this.PedidoSelected != null && this.PedidoSelected !== '') {
              this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x =>
                String(x.pedId) === String(this.PedidoSelected).trim()
              )
            }
            if (this.PagamentoSelected != null) {
              this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pmbTipoPgto == this.PagamentoSelected)
            }
            if (this.AnoSelected != null) {
              this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => this.$moment(x.pmbDataVencimento).format('YYYY') == this.AnoSelected)
            }
            if (this.MesSelected != null) {
              this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => this.$moment(x.pmbDataVencimento).format('M') == this.MesSelected)
            }
            if (this.SituacaSelected != null) {
              if (this.SituacaSelected == 1) {
                this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pmbDataPagamento != null)
              } else if (this.SituacaSelected == 2) {
                this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pmbDataPagamento == null)
              }
            }
            if (this.selectedConsumidor != null) {
              this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.cliId == this.selectedConsumidor.cliId)
            }

            this.ListCobrancas = [...this.ListCobrancasGeral].sort((a, b) =>
              this.$moment(a.pmbDataVencimento).diff(this.$moment(b.pmbDataVencimento))
            )
          })
      }
    },
    ConfirmaPgto (item) {
      this.itemAtual = { ...item }
      this.itemAtual.pmbDataVencimento = this.$moment(item.pmbDataVencimento).format('YYYY-MM-DD')
      this.itemAtual.pmbValorParcela = this.formatarValor(item.pmbValorParcela)
      this.pmbDataPagamento = ''
      this.ajustarVencimentoParcelasFuturas = false
      this.dialogPagamento = true
    },
    isDecimalPtBr2Casas (str) {
      const v = String(str ?? '').trim()
      const re = /^(?:R\$\s*)?-?(?:\d{1,3}(?:\.\d{3})+|\d+),\d{2}$/
      return re.test(v)
    },
    PermiteAjusteVencimento (dataVencimento) {
      if (dataVencimento == '' || dataVencimento == null) return false
      return this.$moment(dataVencimento).isSameOrAfter(this.$moment().startOf('month'), 'day')
    },
    AtualizaPagamento (pmbDataPagamento) {
      // console.log('pmbDataPagamento')
      // console.log(pmbDataPagamento)
      const permiteAjusteVencimento = this.PermiteAjusteVencimento(this.itemAtual.pmbDataVencimento)
      if (permiteAjusteVencimento && (this.itemAtual.pmbDataVencimento == '' || this.itemAtual.pmbDataVencimento == null)) {
        this.$mensagemErro('Selecione Vencimento do pagamento.')
      } else if (this.itemAtual.pmbValorParcela == '' || this.itemAtual.pmbValorParcela == null) {
        this.$mensagemErro('Selecione Valor do pagamento.')
      } else if (!this.isDecimalPtBr2Casas(this.itemAtual.pmbValorParcela)) {
        this.$mensagemErro('Formato do valor invalido (###.###,##).')
      } else {
        const _valorParcela = this.itemAtual.pmbValorParcela.replaceAll('.', '').replaceAll(',', '.')
        const dataPagamento = pmbDataPagamento ? this.$moment(pmbDataPagamento).format('YYYY-MM-DD') : null
        this.$mensagemConfirma('Confirma Alteracoes nessa Fatura?')
          .then((result) => {
            if (result.isConfirmed) {
              // Lógica para excluir o item
              const _dados = {
                PmbId: this.itemAtual.pmbId,
                GarId: this.itemAtual.garId,
                ImoId: this.itemAtual.imoId,
                CliId: this.itemAtual.cliId,
                PedId: this.itemAtual.pedId,
                PmbParcela: this.itemAtual.pmbParcela,
                PmbValorParcela: parseFloat(_valorParcela),
                PmbDataVencimento: permiteAjusteVencimento ? this.$moment(this.itemAtual.pmbDataVencimento).format('YYYY-MM-DD') : null,
                PmbDataPagamento: dataPagamento,
                PmbTipoPgto: this.itemAtual.pmbTipoPgto,
                PmbFormaPgto: this.itemAtual.pmbFormaPgto,
                PmbEnvioBanco: null,
                PmbRetornoBanco: null,
                AjustarVencimentoParcelasFuturas: permiteAjusteVencimento && this.ajustarVencimentoParcelasFuturas
              }
              axios.put('/Telas/ControleCobrancaGarantidoras/UpdateSituacaoPgtoPedidoControle', _dados)
                .then(response => {
                  if (response.status == 200) {
                    this.Filtar()
                    this.dialogPagamento = false
                  }
                })
            }
          })
      }
    },
    montaGrid () {
      this.headers = []
      this.headers.push({ text: '', value: 'select' })
      if (this.User.garid == 0) {
        this.headers.push({ text: 'Garantidora', value: 'garId', sortable: true })
      }
      if (this.User.tpeid != 3) {
        this.headers.push({ text: 'Imobiliaria', value: 'imoId', sortable: true })
      }
      this.headers.push({ text: 'Cliente', value: 'cliNomeEmpresa', sortable: true })
      this.headers.push({ text: 'Documento', value: 'cliDocumento', sortable: true })
      this.headers.push({ text: 'ID contratação', value: 'pedId', sortable: true })
      this.headers.push({ text: 'Parcela', value: 'pmbParcela', sortable: true })
      this.headers.push({ text: 'Valor', value: 'pmbValorParcela', sortable: true })
      this.headers.push({ text: 'Vencimento', value: 'pmbDataVencimento', sortable: true })
      this.headers.push({ text: 'Pagamento', value: 'pmbDataPagamento', sortable: true })
      this.headers.push({ text: 'Tipo', value: 'pmbFormaPgto', sortable: true })

      this.headers.push({ text: 'Ações', value: 'actions' })
    },
    exportCSV () {
      if (this.ListCobrancas.length === 0) {
        alert('Não há dados para exportar.')
        return
      }

      let _Garantidora = 'Todas'
      let _Imobliaria = 'Todas'
      let _FormaPagamento = 'Todas'
      let _Ano = 'Todos'
      let _Mes = 'Todos'

      if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
        _Garantidora = this.ListGarantidorasGeral.filter(x => x.garId == this.GarantidoraSelected)[0].garNomeEmpresa
      }

      if (this.ImobiliariaSelected != '' && this.ImobiliariaSelected != null) {
        _Imobliaria = this.ListImobiliariasGeral.filter(x => x.imoId == this.ImobiliariaSelected)[0].imoNomeEmpresa
      }

      if (this.PagamentoSelected != '' && this.PagamentoSelected != null) {
        _FormaPagamento = this.ListPagamentosGeral.filter(x => x.cfpId == this.PagamentoSelected)[0].cfpNome
      }

      if (this.AnoSelected != '' && this.AnoSelected != null) {
        _Ano = this.ListAnoGeral.filter(x => x.Id == this.AnoSelected)[0].Nome
      }

      if (this.MesSelected != '' && this.MesSelected != null) {
        _Mes = this.ListMesGeral.filter(x => x.Id == this.MesSelected)[0].Nome
      }

      // Cria as linhas de filtros (ajuste os nomes dos filtros conforme necessário)
      const filtroCSV =
                `Garantidora: ${_Garantidora}\n` +
                `Imobiliária: ${_Imobliaria}\n` +
                `Forma Pagamento: ${_FormaPagamento}\n` +
                `Ano: ${_Ano}\n` +
                `Mês: ${_Mes}\n\n`

      const csvHeader = this.headers
        .slice(2)
        .map(h => h.text)
        .join(';') + '\n'

      // 2) Liste as chaves dinamicamente (aqui já só as que sobraram após slice)
      const keys = this.headers
        .slice(2)
        .map(h => h.value)

      const csvRows = this.ListCobrancas
        .map(item => {
          return keys
            .map(key => {
              if (key === 'cliNomeEmpresa' || key === 'cliDocumento') {
                // encontra o cliente correspondente
                const cli = this.ListClientesGeral.find(c => c.cliId === item.cliId) || {}
                return cli[key] || ''
              }
              if (key === 'pmbValorParcela') {
                return this.formatarValor(item.pmbValorParcela)
              }

              if (key === 'pmbDataVencimento' || key === 'pmbDataPagamento') {
                return item[key]
                  ? this.formattedDate(item[key])
                  : ''
              }

              // para os demais campos, pega direto do item
              return item[key] != null ? item[key] : ''
            })
            .join(';')
        })
        .join('\n')

      // Concatena os filtros, o cabeçalho e as linhas de dados
      const csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + filtroCSV + csvHeader + csvRows

      // Cria o link de download
      const encodedUri = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'RelatorioControleCobrancas.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    AtualizarPagamentoMassa () {
      if (!this.NewData) {
        return this.$mensagemErro('Selecione uma data de pagamento.')
      }

      if (this.itemsSelected.length == 0) {
        return this.$mensagemErro('Selecione um registro para confirmar pagamento.')
      }

      this.$mensagemConfirma('Confirma atualização de todos os itens selecionados?')
        .then(result => {
          if (!result.isConfirmed) return
          // console.log('this.itemsSelected')
          // console.log(this.itemsSelected)

          // para cada item selecionado, chama o endpoint
          const promessas = this.itemsSelected.map(item => {
            const payload = {
              PmbId: item.pmbId,
              GarId: item.garId,
              ImoId: item.imoId,
              CliId: item.cliId,
              PedId: item.pedId,
              PmbDataPagamento: this.$moment(this.NewData).format('YYYY-MM-DD'),
              PmbTipoPgto: item.pmbTipoPgto,
              PmbFormaPgto: item.pmbFormaPgto,
              PmbEnvioBanco: null,
              PmbRetornoBanco: null
            }
            return axios.put(
              '/Telas/ControleCobrancaGarantidoras/UpdateSituacaoPgtoPedidoControle',
              payload
            )
          })

          // aguarda todas responderem
          Promise.all(promessas)
            .then(() => {
              this.$mensagemSucesso('Pagamentos atualizados com sucesso.')
              this.Filtar() // recarrega a lista
              this.itemsSelected = [] // limpa seleção
            })
            .catch(() => {
              this.$mensagemErro('Erro ao atualizar alguns pagamentos.')
            })
        })
    },
    async Buscacep (value) {
      if (!value) {
        this.$mensagemAviso('Digite um CEP válido.')
        return null
      }

      const cep = String(value).replace(/\D/g, '')
      if (cep.length !== 8) {
        this.$mensagemAviso('CEP inválido.')
        return null
      }

      try {
        const r = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        const data = r.data
        if (!data || data.erro) {
          this.Retornocep = null
          this.$mensagemAviso('CEP não encontrado.')
          return null
        }

        this.Retornocep = data
        return data
      } catch (e) {
        console.error('Erro Buscacep:', e)
        this.Retornocep = null
        this.$mensagemErro('Erro ao consultar CEP.')
        return null
      }
    },
    async EmissaoNF (value) {
      try {
        const confirm = await this.$mensagemConfirma('Confirma Emissão da Nota?')
        if (!confirm.isConfirmed) return

        // busca endereço do cliente
        const response = await axios.get('/Telas/ControleCobrancaGarantidoras/GetEnderecoByCliClienteEndereco/' + value.cliId)
        if (response.data && response.data.length > 0) {
          this.Endereco = response.data[0]

          if (!this.Endereco.cleCodigoDistrito || this.Endereco.cleCodigoDistrito === '') {
            const _dados = await this.Buscacep(this.Endereco.cleCep)
            if (_dados != null) {
              this.Endereco.cleCodigoDistrito = String(_dados.ibge)
              try {
                const upd = await axios.put('/Telas/ControleCobrancaGarantidoras/UpdateClienteEndereco', this.Endereco)
                if (!(upd.status == 200 || upd.status == 201)) {
                  console.error('Erro ao atualizar endereço')
                }
              } catch (e) {
                console.error('Erro ao atualizar endereço', e)
              }
            }
          }
        }

        const emitir = await axios.put('/Telas/ControleCobrancaGarantidoras/UpdateEmitirNotaFiscal/' + value.pmbId)
        if (emitir.status == 200) {
          this.Filtar()
        }
      } catch (e) {
        console.error('Erro EmissaoNF:', e)
        this.$mensagemErro('Erro ao emitir nota.')
      }
    },
    CancelarNF (item) {
      this.$mensagemConfirma('Confirma Cancelamento da Nota?')
        .then((result) => {
          if (result.isConfirmed) {
            axios.put('/Telas/ControleCobrancaGarantidoras/UpdateCancelarNotaFiscal/' + item.pmbId + '/' + item.idNota)
              .then(response => {
                if (response.status == 200) {
                  this.Filtar()
                }
              })
          }
        })
    },
    BaixaNF (value, tipo) {
      const url = `/Telas/ControleCobrancaGarantidoras/GetFile/${value.pmbId}/${tipo}`

      axios.get(url, { responseType: 'blob' })
        .then(response => {
          console.log('response.data')
          console.log(response.data)
          const blob = new Blob([response.data], { type: response.data.type })
          const fileURL = URL.createObjectURL(blob)

          if (tipo === 1 || tipo === '1') {
            // PDF: abrir em nova aba
            window.open(fileURL, '_blank')
          } else if (tipo === 2 || tipo === '2') {
            // XML: forçar download
            const link = document.createElement('a')
            link.href = fileURL

            // Tenta extrair o nome do arquivo do header (se definido)
            const contentDisposition = response.headers['content-disposition']
            let fileName = 'arquivo.xml' // nome padrão

            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^;"]+)"?/)
              if (fileNameMatch && fileNameMatch[1]) {
                fileName = decodeURIComponent(fileNameMatch[1])
              }
            }

            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(fileURL) // libera a memória
          }
        })
        .catch(error => {
          console.error('Erro ao baixar arquivo:', error)
        })
    },
    ModalStatus (item) {
      axios.get('/Telas/ControleCobrancaGarantidoras/GetRetornoWebhookApi/' + item.pmbId)
        .then(response => {
          this.statusArray = response.data.sort((a, b) => {
            return new Date(b.dataEnvio) - new Date(a.dataEnvio)
          })
          this.dialogStatusNota = true
        })
    },
    async Get () {
      await axios.get('/Telas/ControleCobrancaGarantidoras/GetDados')
        .then(response => {
          this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
            a.garNomeEmpresa.localeCompare(
              b.garNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )
          this.User.tpeid = response.data.tpeId
          this.User.garid = response.data.garId
          this.User.pesid = response.data.pesId
          if (this.User.garid != 0) {
            this.GarantidoraSelected = this.User.garid
            this.BuscaImobiliarias()
          }
          if (this.User.tpeid == 3) {
            this.ImobiliariaSelected = this.User.pesid
          }

          this.ListImobiliariasGeral = response.data.imobiliarias.sort((a, b) =>
            a.imoNomeEmpresa.localeCompare(
              b.imoNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )

          this.ListAnoGeral = []
          const anoAtual = new Date().getFullYear()
          this.ListAnoGeral = Array.from({ length: 7 }, (_, i) => {
            const ano = anoAtual - 1 + i
            return { Id: ano, Nome: String(ano) }
          })

          this.ListPagamentosGeral = response.data.cadFormasPagamentos
          this.ListClientesGeral = response.data.clientes.filter(x => x.cliAtivo).sort((a, b) =>
            a.cliNomeEmpresa.localeCompare(
              b.cliNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )
          this.montaGrid()
        })
    }
  },
  created () {
    this.Get()
  }
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
</style>
